// import Vue from 'vue'
// initial state
// shape: [{ id, quantity }]
const state = () => ({
  mapSelected: [],
  zoomLevel: 6,
  loadingMap: true,
});

// getters
const getters = {
  getSelectedMap: (state) => {
    return state.mapSelected;
  },
  getProvincedSelectedMap: (state) => {
    if (state.mapSelected[0]) return state.mapSelected[0];
    return null;
  },
  getProvincedSelectedMapName: (state) => {
    if (state.mapSelected[0]) return state.mapSelected[0].name;
    return null
  },
  getProvincedSelectedMapCode: (state) => {
    if (state.mapSelected[0]) return state.mapSelected[0].code;
  },
  getAmpSelectedMap: (state) => {
    if (state.mapSelected[1]) return state.mapSelected[1];
    return null;
  },
  getAmpSelectedMapName: (state) => {
    if (state.mapSelected[1]) return state.mapSelected[1].name;
    return null;
  },
  getAmpSelectedMapCode: (state) => {
    if (state.mapSelected[1]) return state.mapSelected[1].code;
    return null;
  },
  getTambonSelectedMap: (state) => {
    if (state.mapSelected[2]) return state.mapSelected[2];
    return null;
  },
  getTambonSelectedMapName: (state) => {
    if (state.mapSelected[2]) return state.mapSelected[2].name;
    return null;
  },
  getTambonSelectedMapCode: (state) => {
    if (state.mapSelected[2]) return state.mapSelected[2].code;
    return null;
  },
  getSelectedLength: (state) => {
    return state.mapSelected.length;
  },
  getZoomLevel: (state) => state.zoomLevel,
  getloadingMapState: (state) => state.loadingMap,
};

// actions
const actions = {
  setLoadingMapState({ commit }, boo) {
    commit("siwtchLoadingMapState", boo);
  },
  pushSelectedFromMap({ commit }, data) {
    commit("pushSelected", data);
  },
  popLastedData({ commit }) {
    commit("popLastedData");
  },
  sliceData({ commit }, sliceTo) {
    commit("slicData", sliceTo);
  },
  increaseZoomMap({ commit }) {
    commit("increaseZoomMap");
  },
  decreaseZoomMap({ commit }) {
    commit("decreaseZoomMap");
  },
  setZoomMap({ commit }, level) {
    commit("setZoomMap", level);
  },
};

// mutations
const mutations = {
  siwtchLoadingMapState(state, boo) {
    state.loadingMap = boo;
  },
  setZoomMap(state, level) {
    state.zoomLevel = level;
  },
  increaseZoomMap(state) {
    state.zoomLevel += 1;
  },
  decreaseZoomMap(state) {
    state.zoomLevel -= 1;
  },
  slicData(state, sliceTo) {
    if (sliceTo < state.mapSelected.length)
      state.mapSelected = state.mapSelected.slice(0, sliceTo);
  },
  pushSelected(state, data) {
    // if (
    //   (this.getters["dashboard/isPRODUCT_STATE"] &&
    //     state.mapSelected.length < 1 && Vue.prototype.$keycloak.authenticated) ||
    //   this.getters["dashboard/isSME_STATE"]
    // )
      state.mapSelected.push(data);
  },
  popLastedData(state) {
    state.mapSelected.pop();
  },
};

export {
  // namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
